import { createContext, useContext } from "react";
import { useHospitalPortalState } from "./useHospitalPortal";

const HospitalPortalContext = createContext(null);

export const HospitalPortalProvider = ({ children }) => {
  const value = useHospitalPortalState();
  return (
    <HospitalPortalContext.Provider value={value}>
      {children}
    </HospitalPortalContext.Provider>
  );
};

export const useHospitalPortalCtx = () => {
  const ctx = useContext(HospitalPortalContext);
  if (!ctx) {
    throw new Error("useHospitalPortalCtx must be used within HospitalPortalProvider");
  }
  return ctx;
};
